import logo from '../assets/img/app-logo.webp';

type Props = {
  size: number;
  /** Pass "" where the brand name is already written beside the logo. */
  alt?: string;
};

const Logo = ({size, alt = 'smartmixin-logo'}: Props) => {
  return <img src={logo} alt={alt} height={size} />;
};

export default Logo;
